import React from "react";

const GlobalDataSummary = () => {
  return (
    <div className="py-8">
      <div className="bg-white shadow border1 rounded-lg p-6 ">
        <h2 className="text-lg font-bold mb-4 font4 font-inter">
          Global data book summary
        </h2>
        <div className="grid grid-cols-2 border border-gray-300 font4 font-dmSans">
          <div className="p-5 border-r-2 border-b bg-gray-100">
            Market revenue in 2023
          </div>
          <div className="p-5 border-b bg-gray-100">USD 406.7 million</div>

          <div className="p-5 border-r-2 border-b">Market revenue in 2030</div>
          <div className="p-5 border-b">USD 554.4 million</div>

          <div className="p-5 border-r-2 border-b bg-gray-100">Growth rate</div>
          <div className="p-5 border-b bg-gray-100">
            4.5% (CAGR from 2023 to 2030)
          </div>

          <div className="p-5 border-r-2 border-b">Market segmentation</div>
          <div className="p-5 border-b">Type, End Use, Application</div>

          <div className="p-5 border-r-2 bg-gray-100">
            Historical data covered
          </div>
          <div className="p-5 bg-gray-100">2018 – 2022</div>
        </div>
      </div>
    </div>
  );
};

export default GlobalDataSummary;
